
import axios from 'axios'

export const sendToken = async (to, amount) => {
  const address = process.env.REACT_APP_token_contract
  try {
    const tx = await axios.post(
      `${process.env.REACT_APP_contract_api}/transferERC20`,
      {
        address,
        to,
        amount: Number(amount),
      },
    )
    return tx
  } catch (error) {
    console.error(error)
  }
}
